/* RESPONSIBLE TEAM: team-fin-qa */
// Bridge route for QA review sidedrawer under received reviews (inbox)
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class InboxReviewsReceivedReviewRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'inbox.reviews.received.review',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(InboxReviewsReceivedReviewRoute);
